import React from 'react';
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
} from 'mdb-react-ui-kit';
import ImportForm from '../components/importForm';

function TutorialPage() {
  var date = localStorage.getItem('lastSuccessfulLogin');
  var reLoginDate = new Date();
  reLoginDate.setHours(reLoginDate.getHours() - 24);
  if (date != null && Number(date) < reLoginDate.getTime()) {
    localStorage.clear();
    window.location.reload(false);
    window.location = '/';
  }

    return (
      <>
        <div className='d-flex justify-content-center my-5' >
          <MDBCard style={{width: '80%'}}>
            <MDBCardBody>
              <MDBCardTitle className='mb-4'>Import</MDBCardTitle>
              <ImportForm />
            </MDBCardBody>
          </MDBCard>
        </div>
      </>
    );
}

export default TutorialPage;
